/**
 * Authentication service
 */
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

class Authentication {
  constructor() {
    this.authenticated = localStorage.getItem("token") || false;
  }

  async signup(payload) {
    payload.email_digest = payload.subscribe || false;
    payload.first_name = payload.firstName;
    payload.last_name = payload.lastName;
    try {
      let response = await axios.post(`${API_URL}/signup/`, payload);
      console.log(response);
      return { status: true, response };
    } catch (err) {
      return { status: false, err };
    }
  }

  async login(username, password) {
    try {
      let response = await axios.post(`${API_URL}/signin/`, {
        email: username,
        password: password
      });
      if (response.data.token) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        return true;
      }
    } catch (err) {
      return false;
    }
  }

  logout() {
    localStorage.clear();
  }

  isAuthenticated() {
    return this.authenticated;
  }
}

export default new Authentication();
